import { CommonSchemaIds } from "../../schemas/common.const.js";
export const dictionary = {
    schema: {
        [CommonSchemaIds.UUID]: {
            title: 'Uuid',
            description: 'The record id.',
        },
        [CommonSchemaIds.NAME]: {
            title: 'Name',
            description: 'The name to use as reference.',
            cti: 'Please supply a name here.',
        },
        [CommonSchemaIds.TITLE]: {
            title: 'Title',
            description: 'Display name.',
            abbr: 'Title',
            cti: 'Please supply a display name here.',
        },
        [CommonSchemaIds.LOCALE]: {
            title: 'Your preferred language',
            description: 'Your preferred language to use when displaying texts and data.',
            abbr: 'Language',
            cti: 'Please select your preferred language.',
        },
        [CommonSchemaIds.UUID_LIST]: {
            title: 'Reference list',
            description: 'List of references.',
            abbr: 'Refs.',
        },
        [CommonSchemaIds.SYSTEM_ADMIN_ROLES]: {
            title: 'Administrator role',
            description: 'Type of system administrator.',
            abbr: 'Admin. role',
        },
        [CommonSchemaIds.ROLE]: {
            title: 'Role',
            description: 'Type of user.',
            abbr: 'Role',
        },
        [CommonSchemaIds.ROLES]: {
            title: 'Permissions',
            description: 'User permissions.',
            abbr: 'Permissions',
        },
        [CommonSchemaIds.RESELLER]: {
            title: 'Reseller',
            description: 'Organisation that manages atlases.',
            abbr: 'Reseller',
        },
        [CommonSchemaIds.DOMAIN]: {
            title: 'Atlas',
            description: 'Atlas used by a client',
            abbr: 'Atlas',
        },
        [CommonSchemaIds.DOMAIN_ADMINISTRATORS]: {
            title: 'Administrators',
            description: 'Account administrators that have full permission.',
            abbr: 'Admins.',
        },
        [CommonSchemaIds.ACTIVE]: {
            title: 'Active',
            description: 'Active or not',
            cti: 'Activate / de-activate.',
        },
        [CommonSchemaIds.DELETED]: {
            title: 'Deleted',
            description: 'Deleted or not',
            cti: 'Delete / restore.',
        },
        [CommonSchemaIds.EMAIL]: {
            title: 'Your e-mail',
            description: 'The e-mail used for signing in.',
            abbr: 'E-mail',
            cti: 'Please specify your e-mail address.',
        },
        [CommonSchemaIds.SECRET]: {
            title: 'Password:Re-type password',
            description: 'You need to prove who you are.:Please re-type to make sure.',
            abbr: 'Password:Re-type password',
            cti: 'Please specify a password.:Please re-type your password.',
        },
        [CommonSchemaIds.JWT]: {
            title: 'JWT',
            description: 'JSON Web Token used in API calls.',
        },
        [CommonSchemaIds.BEARER_TOKEN]: {
            title: 'Bearer Token',
            description: 'Bearer Token to be used as Authorization header value in API calls.',
        },
    },
};
